<template>
  <div class="hr-footer">
    <div class="__container col-xs-12 col-sm-10 col-centered">
      <div class="__content">
        <div class="__description">
          <slot></slot>
        </div>
        <div class="__disclaimer">
          <p>
            {{ t('hr-footer:disclaimer') }}
            <a
              class="__disclaimer-link"
              data-test-id="disclaimer-link"
              :href="disclaimerLink"
              target="__blank"
            >
              {{ t('hr-footer:privacy-policy') }}
            </a>
            {{ t('hr-footer:information') }}
          </p>
        </div>
        <div class="__button">
          <co-button
            class="hr-blue-button"
            data-test-id="hr-button-footer"
            @click="click"
            type="primary"
          >
            {{ button }}
          </co-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CoButton } from '@deputy/copilot2';
import store from '@/store';
import t from '@/lib/i18next';

export default {
  name: 'hrfooter-message',
  components: { CoButton },
  props: {
    button: {
      type: String,
      default: null,
    },
  },
  emits: ['click'],
  setup(_, { emit }) {
    const countryCode = store.state.onboarding?.countryCode || 'AU';
    const disclaimerLink = `https://www.deputy.com/${countryCode.toLowerCase()}/terms/privacy-policy`;

    function click() {
      emit('click');
    }

    return {
      click,
      disclaimerLink,
      t,
    };
  },
};
</script>

<style scoped lang="scss">
@import '~@/core/style-vars.scss';

.hr-footer {
  transition: all 0.5s ease;
  background-color: var(--dpt-surface-color-neutral);
  padding: 20px 0;
  border-top: 1px solid var(--dpt-border-color);

  @media only screen and (max-width: 768px) {
    padding: 0;
  }
}

.__container {
  margin: 0 auto;

  @media only screen and (max-width: 768px) {
    display: block;
  }
}

.__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding: 0 6px;

  @media only screen and (max-width: 768px) {
    padding: 12px 6px;
  }
}

.__description {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--dpt-text-color);
  margin: 0;

  @media only screen and (max-width: 768px) {
    font-size: 1.25rem;
  }
}

.__disclaimer {
  color: var(--dpt-text-color-secondary);
  font-size: 0.875rem;
  font-weight: normal;
  line-height: 1.5;
  margin: 0;

  @media only screen and (max-width: 768px) {
    font-size: 0.875rem;
  }
}

.__disclaimer-link {
  color: var(--dpt-text-color-link);
  text-decoration: none;
}

.__disclaimer-link:hover {
  text-decoration: underline;
}

.__button .hr-blue-button {
  font-size: 1rem;
  font-weight: 600;
  padding: 12px 24px;
  border-radius: 8px;

  @media only screen and (max-width: 768px) {
    font-size: 0.875rem;
    padding: 10px 28px;
  }
}

@media print {
  .hr-footer {
    display: none !important;
  }
}
</style>
